// 工作台卡片api
import { gatewayInstance } from "../server/gateway";

// 工作台查询待办
export async function queryTodoList(body: any = {}) {
  return gatewayInstance.request({
    api: "work.task.queryBackLog",
    method: "POST",
    // @ts-ignore
    body
  });
}

// 工作台查询新闻卡片
export async function queryBanner(body: any = {}) {
  return gatewayInstance.request({
    api: "carousel.getCarouselMap",
    method: "POST",
    // @ts-ignore
    body
  });
}
